
import { Skeleton, SkeletonItem } from 'rm-design';

export default {
  name: 'ProfileMenuSkeleton',
  components: { Skeleton, SkeletonItem }
};
